// Thin fetch wrapper for the /admin backend (/be/admin/*). All endpoints are
// POST + JSON to match the rest of the API. Cookies (the session) ride along
// same-origin; credentials:'include' is belt-and-suspenders.

const BASE = process.env.REACT_APP_BACKEND_URL || '';

export async function adminPost(path, body) {
  let res;
  try {
    res = await fetch(BASE + path, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body || {}),
    });
  } catch (e) {
    return { ok: false, status: 0, data: { message: 'Network error — please try again.' } };
  }
  let data = {};
  try { data = await res.json(); } catch (e) { /* non-JSON */ }
  return { ok: res.ok, status: res.status, data };
}
